import { SVGProps, Ref, forwardRef } from 'react';

export const MaxSolidSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.158 15.253c-1.44 0-2.109-.21-3.271-1.05-.736.945-3.065 1.684-3.166.42 0-.948-.21-1.749-.448-2.623C.989 10.922.667 9.721.667 7.982.667 3.83 4.077.706 8.119.706c4.045 0 7.214 3.278 7.214 7.316a7.2 7.2 0 0 1-2.09 5.098 7.22 7.22 0 0 1-5.085 2.133m.06-10.958c-1.969-.101-3.503 1.26-3.843 3.394-.28 1.767.218 3.919.641 4.03.203.05.715-.363 1.033-.682.527.364 1.141.582 1.78.634a3.75 3.75 0 0 0 3.918-3.489A3.74 3.74 0 0 0 8.217 4.3z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
MaxSolidSize16Glyph.displayName = 'MaxSolidSize16Glyph';
